import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { message, TimePicker } from 'antd';
import dayjs from 'dayjs';
import { FaCalendarDay, FaClock, FaUserMd } from 'react-icons/fa';
import { GrCompliance } from "react-icons/gr";
import { BiChat } from "react-icons/bi";
import 'antd/dist/reset.css';
import Header from '../Header';
import Sidebar from '../Sidebar';
import PropTypes from 'prop-types';
import { addShift, updateShifts } from '../../services/doctor/shift schedule/shift_schedule';
import { useNavigate } from 'react-router-dom';
import { useMessageApi } from '../../services/message api/MessageProvider'; 
const AddSchedule = ({ setEdShift, setEditingShift,setShowAddSchedule }) => {
  const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];



  const [shift, setShift] = useState({
    name: setEditingShift?.name || '', 
    days: setEditingShift?.days || [],
    start_time: setEditingShift?.start_time || null,
    end_time: setEditingShift?.end_time || null,
    allow_online_booking: setEditingShift?.allow_online_booking || false,
    slotType: 'preset',
    slot_duration: setEditingShift?.slot_duration?.toString() || ''
 
  });
    const messageApi = useMessageApi();

  const [errors, setErrors] = useState({});
  const handleDayToggle = (day) => {
    setShift(prev => ({
      ...prev,
      days: prev.days.includes(day) 
        ? prev.days.filter((d) => d !== day) 
        : [...prev.days, day]
    }));
  };

  // Handle input changes
  const handleInputChange = (field, value) => {
    setShift(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error for this field if it exists
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};

    if (!shift.name.trim()) {
      newErrors.name = 'Shift name is required';
    }

    if (shift.days.length === 0) {
      newErrors.days = 'At least one day must be selected';
    }

    if (!shift.start_time) {
      newErrors.startTime = 'Start time is required';
    }

    if (!shift.end_time) {
      newErrors.endTime = 'End time is required';
    } else if (dayjs(shift.start_time, 'hh:mm A') && dayjs(shift.end_time, 'hh:mm A').isBefore(dayjs(shift.start_time, 'hh:mm A'))) {
      newErrors.endTime = 'End time must be after start time';
    }

    if (shift.slotType === 'custom' && (isNaN(shift.slot_duration) || shift.slot_duration <= 0)) {
      newErrors.slot_duration = 'Slot duration must be a positive number';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
    
  };

  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: 'topRight', // <-- key part for right side
  });
  // const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const handlAddSubmit = async(e) => {
    e.preventDefault();

    e.preventDefault();
    
      if (validateForm()) {
        console.log("Form validation successfully!", shift);
        try {
          const result = await addShift(shift); 
          if (result.success) {
            messageApi.open({
              type: 'success',
              content: 'Shift added successfully!',
            });
            setShowAddSchedule(false);
            navigate('/manage-shifts');
          } else {
            const errors = result?.error;
      
            Object.entries(errors).forEach(([field, messages]) => {
              const messageArray = Array.isArray(messages) ? messages : [messages];
            
              messageArray.forEach((msg) => {
                messageApi.open({
                  type: 'error',
                  content: `${field}: ${msg}`,
                  style: {
                    maxWidth: '300px',
                    minWidth: '300px',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    marginLeft: 'auto', // aligns to right in combination with topRight
                    marginRight: '0',
                  },
                });
              });
            });
            
            
          }
        } catch (error) {
          console.error("Error adding hospital:", error?.message);
          // Show error to user
        }

      } else {
        console.log("Form validation failed");
      }
  };
  const handlUpdateSubmit = async (e) => {
    e.preventDefault();

    e.preventDefault();
    
      if (validateForm()) {
        console.log("Form submitted successfully!", shift);
        try {
          const result = await updateShifts(setEditingShift?.id,shift); 
          if (result.success) {
            // await messageApi.open({
            //   type: 'success',
            //   content: 'Shift updated successfully!',
            // });
            message.success("Shift added successfully!");

            setShowAddSchedule(false);

            // navigate("/manage-shifts");
          } else {
            const errors = result?.error;
      
            Object.entries(errors).forEach(([field, messages]) => {
              const messageArray = Array.isArray(messages) ? messages : [messages];
            
              messageArray.forEach(async (msg) => {
                await messageApi.open({
                  type: 'error',
                  content: `${field}: ${msg}`,
                  style: {
                    maxWidth: '300px',
                    minWidth: '300px',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    marginLeft: 'auto', // aligns to right in combination with topRight
                    marginRight: '0',
                  },
                });
              });
            });
            
            
          }
        } catch (error) {
          console.error("Error adding hospital:", error?.message);
          // Show error to user
        }
      } else {
        console.log("Form validation failed");
      }
  };

  useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
    }, []);

  return (
    <>
    <div>
      <Sidebar activeClassName="add-schedule" />
      <div className="page-wrapper-doctor">
      
        <div className="content">
          <div className="page-header">
            <h3 className="page-title font-weight-bold">Doctor Schedule</h3>
          </div>

          <div className="card">
            <div className="card-body d-flex">
              {/* Vertical Stepper */}
              <div className="stepper-vertical p-3">
                {/* Stepper icons remain same as before */}
              </div>

              {/* Form Content */}
              <div className="flex-grow-1 ps-4">
                {/* Shift Name */}
                <div className="form-group mt-4">
                  <label>Shift Name</label>
                  <input
                    type="text"
                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                    value={shift.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    placeholder="Enter shift name"
                  />
                  {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                </div>

                {/* Day Selection */}
                {shift.name && (
                  <div className="form-group mt-2">
                    <label>Select days</label>
                    {errors.days && <div className="text-danger">{errors.days}</div>}
                    <div className="d-flex flex-wrap gap-2">
                      {daysOfWeek.map((day) => (
                        <button
                          key={day}
                          className={`btn ${shift.days.includes(day) ? 'btn-primary' : 'btn-outline-primary'}`}
                          onClick={() => handleDayToggle(day)}
                        >
                          {day}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Shift Timings */}
                {shift.name && shift.days.length > 0 && (
                  <div className="form-group mt-4">
                    <label>Shift Timings</label>
                    <div className="d-flex gap-3 align-items-start">
                      <div>
                        <TimePicker
                          className={`form-control ${errors.startTime ? 'is-invalid' : ''}`}
                          onChange={(time) =>     handleInputChange('start_time', time ? time.format('hh:mm A') : '')}

                          format="hh:mm A"
                          use12Hours
                          value={
                            shift.start_time && typeof shift.start_time === 'string'
                              ? dayjs(shift.start_time, 'hh:mm A')
                              : null
                          }
                        />
                        {errors.startTime && <div className="invalid-feedback">{errors.startTime}</div>}
                      </div>
                      <label className="mt-2">to</label>
                      <div>
                        <TimePicker
                          className={`form-control ${errors.endTime ? 'is-invalid' : ''}`}
                          onChange={(time) =>     handleInputChange('end_time', time ? time.format('hh:mm A') : '')}
                          format="hh:mm A"
                          use12Hours
                          value={
                            shift.end_time && typeof shift.end_time === 'string'
                              ? dayjs(shift.end_time, 'hh:mm A')
                              : null
                          }
                        />
                        {errors.endTime && <div className="invalid-feedback">{errors.endTime}</div>}
                      </div>
                    </div>
                  </div>
                )}

                {/* Online Booking */}
                {shift.name && shift.days.length > 0 && shift.start_time && shift.end_time && (
                  <div className="form-group mt-4">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={shift.allow_online_booking}
                        onChange={(e) => handleInputChange('allow_online_booking', e.target.checked)}
                      />
                      <label className="form-check-label">
                        Allow online appointments
                      </label>
                    </div>
                  </div>
                )}

                {/* Slot Duration */}
                {shift.name && shift.days.length > 0 && shift.start_time && shift.end_time && (
                  <div className="form-group mt-4">
                    <label>Slot Duration</label>
                    {errors.slot_duration && <div className="text-danger">{errors.slot_duration}</div>}
                    <div className="d-flex gap-2 flex-wrap">
                      {["5", "10", "15", "20", "30"].map((duration) => (
                        <button
                          key={duration}
                          className={`btn ${shift.slot_duration === duration ? 'btn-primary' : 'btn-outline-primary'}`}
                          onClick={() => {
                            handleInputChange('slot_duration', duration || '');

                            handleInputChange('slotType', 'preset');
                          }}
                        >
                          {duration} Mins 
                          
                        </button>
                      ))}
                      <button
                        className={`btn ${shift.slotType === 'custom' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleInputChange('slotType', 'custom')}
                      >
                        Custom
                      </button>
                    </div>

                    {shift.slotType === 'custom' && (
                      <div className="mt-3">
                        <input
                          type="string"
                          className={`form-control ${errors.slot_duration ? 'is-invalid' : ''}`}
                          value={shift.slot_duration}
                          onChange={(e) => handleInputChange('slot_duration', (e.target.value))}
                          min="1"
                          placeholder="Enter minutes"
                        />
                      </div>
                    )}
                  </div>
                )}

                {setEdShift?
                  <button
                    className="btn btn-success mt-4 me-3"
                    onClick={handlUpdateSubmit}
                  >
                     Update Shift
                  </button>
                  :
                  <button
                    className="btn btn-success mt-4 me-3"
                    onClick={handlAddSubmit}
                  >
                     Add Shift
                  </button>
                }
              </div>
            </div>
          </div>

         
        </div>
      </div>
    </div>
    </>
  );
};

// PropTypes validation
AddSchedule.propTypes = {
  setEdShift: PropTypes.bool,
  setEditingShift: PropTypes.number,
  setShowAddSchedule: PropTypes.func.isRequired,
};

export default AddSchedule;
